import Vue from 'vue';
import VueRouter from 'vue-router';
import utils from './helpers/utils';
import store from './store'; //Vuex
import Constants from './helpers/constants';

const vm = new Vue();

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'main',
        component: () => import('Pages/main/PageMain'),
        // component: PageMain,
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('Pages/login/PageLogin'),
        // component: Login
    },
    {
        path: '/init',
        name: 'init',
        component: () => import('Pages/PageInit'),
        // component: Login
    },
    {
        path: '/registration',
        name: 'registration',
        component: () => import('Pages/registration/PageRegistration'),
    },
    {
        path: '/verify/:userId/:hash/',
        name: 'verify',
        component: () => import('Pages/verifyEmail/PageVerifyEmail'),
    },
    {
        path: '/verify-email',
        name: 'verify-email',
        component: () => import('Pages/sendVerifyEmail/PageSendVerifyEmail'),
    },
    // {
    //     path: '/event/:eventId/:tradingTypeId/:marketId',
    //     name: 'event',
    //     meta: {
    //         title: 'event',
    //         menu: 'event',
    //         breadcrumb: 'event',
    //     },
    //     component: () => import('Pages/event/PageEvent'),
    // },
    {
        path: '/dballTradingFeed',
        name: 'feedDball',
        meta: {
            title: 'pregame',
            isAllowedManualBetting: true,
            isLive: false,
            tradingTypeId: Constants.TRADING_TYPE_ORDER,
            menu: 'markets',
            breadcrumb: 'breadcrumb_pregame',
            moduleName: 'FeedDballModule',
        },
        component: () => import('Pages/feed/dball/PageFeedDball'),
    },
    {
        path: '/dballBotFeed',
        name: 'feedDballBot',
        meta: {
            title: 'botPregame',
            isAllowedManualBetting: false,
            isLive: false,
            tradingTypeId: Constants.TRADING_TYPE_BOT,
            menu: 'markets',
            breadcrumb: 'breadcrumb_botPregame',
            moduleName: 'FeedDballModule',
        },
        component: () => import('Pages/feed/dball/PageFeedDball'),
    },
    {
        path: '/liveTradingFeed',
        name: 'feedLive',
        meta: {
            title: 'live',
            isAllowedManualBetting: true,
            isLive: true,
            tradingTypeId: Constants.TRADING_TYPE_ORDER,
            menu: 'markets',
            breadcrumb: 'breadcrumb_live',
            moduleName: 'FeedLiveModule',
        },
        component: () => import('Pages/feed/live/PageFeedLive'),
        // component: feedLive
    },
    {
        path: '/liveBotFeed',
        name: 'feedLiveBot',
        meta: {
            title: 'botLiveFeed',
            isAllowedManualBetting: false,
            isLive: true,
            tradingTypeId: Constants.TRADING_TYPE_BOT,
            menu: 'markets',
            breadcrumb: 'breadcrumb_botLiveFeed',
            moduleName: 'FeedLiveBotModule',
        },
        component: () => import('Pages/feed/liveBot/PageFeedLiveBot'),
        // component: feedLive
    },
    {
        path: '/favourite',
        name: 'favourite',
        meta: {
            title: 'favourite',
            isAllowedManualBetting: true,
            tradingTypeId: Constants.TRADING_TYPE_ORDER,
            menu: 'markets',
            breadcrumb: 'breadcrumb_favourite',
            moduleName: 'BoardModule',
        },
        component: () => import('Pages/feed/board/PageBoard'),
        // component: feedLive
    },
    {
        path: '/bet',
        name: 'bet',
        meta: {
            title: 'bets',
            menu: 'trading',
            breadcrumb: 'bets',
            moduleName: 'BetModule',
        },
        component: () => import('Pages/bet/PageBet'),
        // component: Bet
    },
    {
        path: '/betFail',
        name: 'betFail',
        meta: {
            title: 'errorLog',
            menu: 'trading',
            breadcrumb: 'errorLog',
            moduleName: 'BetFailModule',
        },
        component: () => import('Pages/betFail/PageBetFail'),
        // component: BetFail
    },
    {
        path: '/bot',
        name: 'bot',
        meta: {
            title: 'bots',
            menu: 'tools',
            breadcrumb: utils.getPlatform() === Constants.PLATFORM_TRADEBALL ? 'botManagement' : 'bots',
            moduleName: 'BotModule',
        },
        component: () => import('Pages/bot/PageBot'),
        // component: Bot
    },
    {
        path: '/team',
        name: 'team',
        meta: {
            title: 'teams',
            menu: 'tools',
            breadcrumb: 'teams',
            moduleName: 'TeamModule',
        },
        component: () => import('Pages/team/PageTeam'),
        // component: League
    },
    {
        path: '/league',
        name: 'league',
        meta: {
            title: 'leagues',
            menu: 'tools',
            breadcrumb: 'leagues',
            moduleName: 'LeagueModule',
        },
        component: () => import('Pages/league/PageLeague'),
        // component: League
    },
    {
        path: '/leagueGroup',
        name: 'leagueGroup',
        meta: {
            title: 'leagueGroups',
            menu: 'tools',
            breadcrumb: 'leagueGroups',
            moduleName: 'LeagueGroupModule',
        },
        component: () => import('Pages/leagueGroup/PageLeagueGroup'),
        // component: LeagueGroup
    },
    {
        path: '/order',
        name: 'order',
        meta: {
            title: 'orders',
            menu: 'trading',
            breadcrumb: 'orders',
            moduleName: 'OrderModule',
        },
        component: () => import('Pages/order/PageOrder'),
        // component: League
    },
    {
        path: '/terms-conditions',
        name: 'terms',
        component: () => import('Pages/PageTermsConditions'),
        // component: TermsConditions
    },
    {
        path: '/guide',
        name: 'guide',
        component: () => import('Pages/PageGuide'),
        // component: Guide
    },
    {
        path: '/forgot-password',
        name: 'forgot-password',
        component: () => import('Pages/forgotPassword/PageForgotPassword'),
        // component: ForgotPassword
    },
    {
        path: '/reset-password/:token',
        name: 'reset-password',
        component: () => import('Pages/resetPassword/PageResetPassword'),
        // component: ResetPassword
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: () => import('./pages/notification/PageNotification'),
        meta: {
            moduleName: 'NotificationModule',
        },
        // component: Notification
    },
    {
        path: '/*',
        redirect: '/liveTradingFeed',
    },
];

//const vm = new Vue();
const router = new VueRouter({
    mode: 'history',
    routes,
});

/**
 * Check if rout has query params
 *
 * @param route
 * @returns {boolean}
 */
function hasQueryParams(route) {
    return !!Object.keys(route.query).length;
}

router.beforeEach((to, from, next) => {
    const exist = router.matcher.getRoutes().some((route) => {
        if (route.name === to.name) {
            return true;
        } else if (route.regex) {
            let regex = new RegExp(route.regex);

            return regex.test(to.name);
        }
        return false;
    });

    if (!exist) {
        router.push({ name: 'feedLive' });
    }

    if (from.name === 'login') {
        if (localStorage.hasOwnProperty('isDark')) {
            router.app.$vuetify.theme.dark = JSON.parse(localStorage.getItem('isDark'));
        }
    }

    if (to.name === 'init') {
        next();
    } else if (
        to.name === 'login' ||
        to.name === 'registration' ||
        to.name === 'verify' ||
        to.name === 'verify-email' ||
        to.name === 'reset-password' ||
        to.name === 'forgot-password' ||
        to.name === 'main'
    ) {
        router.app.$vuetify.theme.dark = false;

        if (store.getters['UserModule/getToken']) {
            router.push({ name: 'feedLive' });
        } else {
            if (!hasQueryParams(to) && hasQueryParams(from)) {
                next({ name: to.name, query: from.query });
            } else {
                next();
            }
        }
    } else {
        if (!store.getters['UserModule/getUser'] && to.name !== 'terms' && to.name !== 'guide' && utils.getPlatform() === Constants.PLATFORM_TRADEBALL) {
            next({ name: 'login' });
        } else {
            if (utils.getPlatform() !== Constants.PLATFORM_TRADEBALL) {
                let title = '';
                if (to.meta && (to.meta.menu || to.meta.breadcrumb)) {
                    if (to.meta.menu) {
                        title = store.$i18n.t('menu.' + to.meta.menu) + ' > ';
                    }
                    if (to.meta.breadcrumb) {
                        title += store.$i18n.t('menu.' + to.meta.breadcrumb);
                    }
                } else {
                    title = _.capitalize(to.name);
                }

                let message = JSON.stringify({
                    type: 'routeChange',
                    href: to.path.replace('/', ''),
                    title: title,
                });

                console.log('Send msg to parent: ' + message);
                window.parent.postMessage(message, '*');
            }

            // if (!hasQueryParams(to) && hasQueryParams(from) && from.name !== 'login') {
            //     next({ name: to.name, query: from.query });
            // } else {
            utils.updateBreadcrumbs(to.name);
            next();
            // }
        }
    }
    //check if user already loaded and WebSocket not started yet
    /*if (store.getters['UserModule/getUser'] && !store.getters['isConnected']) {
        console.log('Connect to WS');
        vm.$connect();
    }*/
});

// router.afterEach(() => {
//     if (vm.$socket && vm.$socket.readyState) {
//         let data = { pageUrl: window.location.toString() };
//
//         store.dispatch('sendObj', {
//             event: 'updateUserData',
//             data: data,
//         });
//
//         // vm.$socket.sendObj({
//         //     event: 'updateUserData',
//         //     data: data,
//         // });
//     }
// });

export default router;
